<!-- Header -->
<header>
  <div class="header-container">
    <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" />

    <nav>
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <ng-container *ngIf="isLoggedIn; else loginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="router.navigate(['/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #loginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="login()">Login / Signup</a>
      </ng-template>
    </nav>

    <button class="mobile-menu-btn" (click)="toggleMobileMenu()">☰</button>
  </div>

  <div class="mobile-menu" [class.active]="mobileMenuOpen">
    <div class="header-container">
      <div style="width: 100%;">
        <nav class="mobile-nav">
          <a href="https://lex-z.ai/">Find Lawyers</a>
          <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
          <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
          <a href="https://lex-z.ai/products/">Products</a>
          <a href="https://lex-z.ai/blogs/">Resources</a>
          <ng-container *ngIf="isLoggedIn; else mobileLoginBtn">
            <a href="javascript:void(0)" class="my-appointments-btn"
               (click)="mobileMenuOpen = false; router.navigate(['/appointments'])">
              My Appointments
            </a>
          </ng-container>
          <ng-template #mobileLoginBtn>
            <a href="javascript:void(0)" class="login-signup-btn"
               (click)="mobileMenuOpen = false; login()">Login / Signup</a>
          </ng-template>
        </nav>
      </div>
    </div>
  </div>
</header>

<!-- Construction Section -->
<section class="construction-section">
        <div class="construction-container">
            <div class="construction-content">
                <div class="construction-icon">
                    <i class="fas fa-book-open"></i>
                </div>
                <h1>{{title}}</h1>
                <h2>Page Under Construction</h2>
                <p class="construction-message">Interesting content coming soon</p>
                <p class="construction-description">
                    Diligently verify the qualifications and track records of lawyers to ensure you make decisive and informed choices. Check back soon!
                </p>
                <a href="index.html" class="back-button">
                    <i class="fas fa-arrow-left"></i>
                    Back to Main Website
                </a>
            </div>
            <div class="construction-animation">
                <div class="gear gear1">
                    <i class="fas fa-cog"></i>
                </div>
                <div class="gear gear2">
                    <i class="fas fa-cog"></i>
                </div>
                <div class="gear gear3">
                    <i class="fas fa-cog"></i>
                </div>
            </div>
        </div>
</section>

<!-- Footer -->
<footer>
  <div class="footer-container">
    <div class="footer-bottom">
      <a  alt="terms of service"
            href="https://digicoffer.com/digicoffer_terms.pdf">Terms of Service</a>
      <span>|</span>
      <a alt="privacy policy" href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policy</a>
      <span>|</span>
      <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookie Policy</a>
    </div>

    <div class="footer-credit">
      © {{ currentYear }} Lex-Z. All rights reserved.
    </div>
  </div>
</footer>